import {Component, Input} from '@angular/core';
import {FormModalService} from "./form-modal.service";

@Component({
    selector: 'form-modal',
    providers: [],
    templateUrl: './form-modal.component.html'
})
export class FormModalComponent {
    @Input() title: string = '';
    @Input() name: string = '';

    constructor(private formModalService: FormModalService){}

    getFormModal(){
        return this.formModalService;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/form-modal/form-modal.component.ts